import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateEmbeddingProviderMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.embeddingProviders.create.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async () => {
            utils.embeddingProviders.findAll.invalidate();
            toast.success("Embedding provider created successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useUpdateEmbeddingProviderMutation = (setLoading?: (loading: boolean) => void, setError?: (error: string) => void) => {
    const utils = trpc.useUtils();
    return trpc.embeddingProviders.update.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async (data) => {
            utils.embeddingProviders.findAll.invalidate();
            utils.embeddingProviders.findById.invalidate({ id: data.id });
            utils.embeddingProviders.findByProvider.invalidate({ provider: data.provider });
            toast.success("Embedding provider updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useSetEnabledEmbeddingProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.embeddingProviders.setEnabled.useMutation({
        onSuccess: async (data) => {
            utils.embeddingProviders.findAll.invalidate();
            utils.embeddingProviders.findEnabled.invalidate();
            toast.success(`Embedding provider ${data.enabled ? "enabled" : "disabled"} successfully`);
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};

export const useDeleteEmbeddingProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.embeddingProviders.delete.useMutation({
        onSuccess: async () => {
            utils.embeddingProviders.findAll.invalidate();
            toast.success("Embedding provider deleted successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
